<template>
<span class="px-0">
    <template v-if="selectable">
        <el-select :disabled="registerActive == false" :value="status" class="select-status" :class="!registerActive ? 'bgc-nlightone c-nmidtwo' : status == 1 ? 'bgc-sgreenone c-sgreenfour' : 'bgc-sorangeone c-sorangefive'" placeholder="Selecionar status" @change="handleChange($event)">
            <el-option label="Pendente" :value="0"></el-option>
            <el-option label="Em análise" :value="2"></el-option>
            <el-option label="Em revisão" :value="3"></el-option>
            <el-option label="Completo" :value="1"></el-option>
        </el-select>
    </template>
    <span v-else :class="validateStatusClass">
        {{ validateStatus }}
    </span>
    <ChangeStatusRegister v-if="selectable" :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @updateStatus="changeRegisterStatus()"/>
</span>
</template>

<script> 
import updateRegisterStatusCompany from '@/api/updateRegisterStatusCompany'
import ChangeStatusRegister from '@/components/modals/ChangeStatusRegister'

export default {
    components: {
        ChangeStatusRegister,
    },
    props: {
        status: {
            default: null
        },
        cnpjId: {
            default: ''
        },
        selectable: {
            type: Boolean,
            default: false
        },
        registerActive: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dialogVisible: false,
            statusToChange: ''
        }
    },
    computed: {
        validateStatus() {
            let literalStatus = ''

            switch (this.status) {
                case 0:
                    literalStatus = 'PENDENTE' 
                    break
                case 1:
                    literalStatus = 'COMPLETO' 
                    break
                case 2:
                    literalStatus = 'EM ANÁLISE' 
                    break
                case 3:
                    literalStatus = 'EM REVISÃO' 
                    break
                case 4:
                    literalStatus = 'EM ASSINATURA' 
                    break
                case null:
                    literalStatus = '-'
                    break
            }

            return literalStatus
        },
        validateStatusClass() {
            let statusClass = ''

            switch (this.status) {
                case 1:
                    statusClass = 'bgc-sgreenone c-greenfour' 
                    break
                case null:
                    statusClass = ''
                    break
                default:
                    statusClass = 'bgc-sorangeone c-sorangefive' 
                    break
            }

            return statusClass
        }
    },
    methods: {
        handleChange(status) {
            this.statusToChange = status
            this.dialogVisible = true
        },
        async changeRegisterStatus() {
            this.dialogVisible = false
            const result = await updateRegisterStatusCompany(this.cnpjId, { status: this.statusToChange }, this.getWhiteLabel)
            if (result.ok) {
                this.$notify({
                    title: 'Status alterado com sucesso!',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
                const companies =  this.$store.state.companies.companies.map((company) => {
                        if (company.cnpjId == this.cnpjId) {
                            company.cnpj.registerComplete = this.statusToChange
                            company.cnpj.updatedAt = new Date()
                            return company
                        } else {
                            return company
                        }
                    }
                )
                this.$store.commit('companies/setCompanies', companies)

            } else {
                this.$notify({
                    title: 'Ops, algo aconteceu de errado!',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
span {
    display: inline-flex;
    justify-content: space-between;
    padding: 4px 8px;
    border-radius: 26px;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
}
</style>